var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "home-popup", attrs: { role: "list" } },
    _vm._l(Object.entries(_vm.categories), function ([name, data]) {
      return _c(
        "div",
        {
          key: name,
          staticClass: "category-item",
          class: { main: data.code !== null },
          attrs: { role: "listitem" },
        },
        [
          _c("a", { attrs: { href: data.link, target: "_blank" } }, [
            _c("svg", { attrs: { "aria-hidden": "true" } }, [
              _c("use", {
                attrs: {
                  href: "#header-icon-" + data.icon,
                  "xlink:href": "#header-icon-" + data.icon,
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "name" }, [_vm._v(_vm._s(name))]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "count" },
              [data.count !== null ? [_vm._v(_vm._s(data.count))] : _vm._e()],
              2
            ),
          ]),
          _vm._v(" "),
          data.subCategories
            ? _c(
                "div",
                { staticClass: "sub-regions-popup popup" },
                _vm._l(
                  Object.entries(data.subCategories),
                  function ([regionName, url]) {
                    return _c(
                      "a",
                      {
                        key: regionName,
                        staticClass: "sub-region",
                        attrs: { href: url, target: "_blank" },
                      },
                      [_vm._v(_vm._s(regionName))]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }